module.exports = __webpack_public_path__ + "static/media/xp-banner1.2c393697.jpg";